import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-partners',
  templateUrl: './brand-partners.component.html',
  styleUrls: ['./brand-partners.component.scss',],
})
export class BrandPartnersComponent {

  partnerImages =
    [
      { brand: 'Aeris', icon: 'aeris.svg', },
      { brand: 'Bira', icon: 'bira.svg', },
      { brand: 'Citymall', icon: 'citymall.svg', },
      { brand: 'Cleartax', icon: 'cleartax.svg', },
      { brand: 'Cnh', icon: 'cnh.svg', },
      { brand: 'Gameskraft', icon: 'gameskraft.svg', },
      { brand: 'Hays', icon: 'hays.svg', },
      { brand: 'Hike', icon: 'hike.svg', },
      { brand: 'Indiagold', icon: 'indiagold.svg', },
      { brand: 'Lithium', icon: 'lithium.svg', },
      { brand: 'Livspace', icon: 'livspace.svg', },
      { brand: 'McD', icon: 'mcD.svg', },
      { brand: 'Metro', icon: 'metro.svg', },
      { brand: 'Moneytap', icon: 'moneytap.svg', },
      { brand: 'Pagarbook', icon: 'pagarbook.svg', },
      { brand: 'Peoplestrong', icon: 'peoplestrong.svg', },
      { brand: 'Rapido', icon: 'rapido.svg', },
      { brand: 'Rentomojo', icon: 'rentomojo.svg', },
      { brand: 'Safeexpress', icon: 'safeexpress.svg', },
      { brand: 'Simplilearn', icon: 'simplilearn.svg', },
      { brand: 'Snapdeal', icon: 'snapdeal.svg', },
    ];

}
